if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cartNotification = document.querySelector("cart-notification");
			}

			async onSubmitHandler(event) {
				event.preventDefault();
				let addons = document.querySelectorAll('.add-on__item');
				const submitButton = this.querySelector('[type="submit"]');
				if (submitButton.classList.contains("loading")) return;

				this.handleErrorMessage();
				// this.cartNotification.setActiveElement(document.activeElement);

				submitButton.setAttribute("aria-disabled", true);
				submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner").classList.remove(
					"hidden"
				);

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				// delete config.headers["Content-Type"];

				// const formData = new FormData(this.form);
				// formData.set(
				// 	"id",
				// 	document.querySelector("input[name=id]").value
				// );
				let selling_plan = '';
				if (document.querySelector('product-form input[name="selling_plan"]') && document.querySelector('product-form input[name="selling_plan"]').value != null) {
					selling_plan = document.querySelector('product-form input[name="selling_plan"]').value;
				}
				let formData = {
					'items': [{
						'id': document.querySelector('product-form input[name="id"]').value,
						'quantity': document.querySelector('product-form .quantity__input').value,
						'selling_plan': selling_plan
					}]
				};
				addons.forEach(addon => {
					if (addon.hasAttribute('selected')) {
						let selectedVariant = addon.querySelector('.item__atc button').getAttribute('data-variant');
						formData.items.push({
							id: selectedVariant,
							quantity: 1
						});
					}
				});
				// console.log(document.querySelector(".select__select[name=id]").value);
				// formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
				// formData.append("sections_url", window.location.pathname);
				config.body = JSON.stringify(formData);
				fetch(`${routes.cart_add_url}`, config)
					.then((response) => {
						return response.json();
					})
					.then((response) => {
						if (document.querySelector('#main-add-to-cart').hasAttribute('data-cross-selling')) {
							// document.querySelector('body').classList.add('has-cross-selling');
							// if (window.location.href.includes('?')) {
							// 	window.location.href = window.location.href + '&view=cross_selling';
							// } else {
							// 	window.location.href = window.location.href + '?view=cross_selling';
							// }
						}
						if (response.status) {
							this.handleErrorMessage(response.description);
							return;
						}

						const cart = document.querySelector("#rebuy-cart");
						cart.classList.add("is-visible");
						this.cartNotification.renderContents(response);
					})
					.catch((e) => {
						// console.error(e);
					})
					.finally(() => {
						submitButton.classList.remove("loading");
						submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading-overlay__spinner").classList.add(
							"hidden"
						);
					});
				document.querySelector('ajax-cart').openCart();
				document.querySelector('ajax-cart').getCart();
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
